import { ContentDocumentMediaType } from '../../content-document.model';
import { TruncateHtmlPipe } from '../../../../data-formatting/truncate-html.pipe';

export class ContentDocumentTruncationTransformer {

    private static TRUNCATION_LENGTH_BODY_EDITORIAL = 140;
    private static TRUNCATION_LENGTH_BODY_SOCIAL = 280;
    private static TRUNCATION_LENGTH_INGRESS = 140;
    private static TRUNCATION_LENGTH_TITLE = 140;

    private static socialMediaTypes = [
        ContentDocumentMediaType.Blog,
        ContentDocumentMediaType.Comments,
        ContentDocumentMediaType.Facebook,
        ContentDocumentMediaType.Forums,
        ContentDocumentMediaType.Instagram,
        ContentDocumentMediaType.Twitter,
        ContentDocumentMediaType.Youtube
    ];

    private static truncateHtml = new TruncateHtmlPipe();

    public static transform(document: any): any {
        const newDocument = {...document};

        if (newDocument.body) {
            const length = this.isSocial(document) ? 
                this.TRUNCATION_LENGTH_BODY_SOCIAL :
                this.TRUNCATION_LENGTH_BODY_EDITORIAL;
                newDocument.body = this.truncate(newDocument.body, length);
        }

        if (newDocument.ingress) {
            newDocument.ingress = this.truncate(newDocument.ingress, this.TRUNCATION_LENGTH_INGRESS);
        }

        if (newDocument.title) {
            newDocument.title = this.truncate(newDocument.title, this.TRUNCATION_LENGTH_TITLE);
        }

        return newDocument;
    }

    private static truncate(text: String, length: Number): String {
        if (text.length > length) {
            return this.truncateHtml.truncateHtml(text, length, true);
        } else {
            return text;
        }
    }

    private static isSocial(document: any): boolean {
        const mediaType = document.mediaType;
        return this.socialMediaTypes.indexOf(mediaType) !== -1;
    }
}


// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/transformers/content-document-truncation.transformer.ts